import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleHomeSectionClick } from "./homeSectionNav";
import { GetGlobalSettings } from "../../website/services/website.services";
import { addData } from "../../../redux/slices/globalDetails";

const quickLinks = [
  { name: "About AstroAdi", href: "/page/user-about-us" },
  { name: "FAQ", href: "/faq" },
  { name: "Privacy Policy", href: "/page/user-privacy-policy" },
  { name: "Terms & Conditions", href: "/page/user-terms-service" },
  { name: "Contact Us", href: "/contact" },
];

const UserFooter = () => {
  const dispatch = useDispatch();
  const globalData = useSelector((state) => state.globalData?.data);
  const socialLinks = Array.isArray(globalData?.social_media_details)
    ? globalData.social_media_details.filter((item) => item?.link)
    : [];

  useEffect(() => {
    if (globalData) return;
    GetGlobalSettings()
      .then((response) => {
        if (response?.success && response.data) {
          dispatch(addData(response.data));
        }
      })
      .catch((error) => {
        console.log("global settings error ====> ", error);
      });
  }, [dispatch, globalData]);

  return (
    <footer className="bg-gray-100 py-12 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-12">
          <div className="md:col-span-1 lg:col-span-2 space-y-4">
            <div className="flex flex-col items-start space-y-1">
              <Link to="/" className="no-underline">
                <img src="/images/footer-logo.svg" alt="footer-logo" />
              </Link>
            </div>

            <p className="web-body-md text-gray-600 !leading-relaxed max-w-sm">
              Discover clarity and guidance with Astro Adi. Offering personalized horoscopes,
              kundli analysis, certified remedies, and expert astrological consultations to light your path.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="web-h4 text-gray-950 mb-4">Quick Links</h3>
            <ul className="space-y-5 !list-none p-0">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    onClick={(e) => handleHomeSectionClick(e, link.href)}
                    className="web-body-lg text-gray-950 hover:text-[#DEA916] !no-underline transition-colors duration-200 text-base"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {socialLinks.length > 0 ? (
            <div className="space-y-4">
              <h3 className="web-h4 text-gray-950 mb-4">Social Media</h3>
              <div className="flex flex-wrap gap-3">
                {socialLinks.map((item, index) => (
                  <a
                    key={`${item.title || item.link}-${index}`}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={item.title || "Social media"}
                    className="inline-flex w-9 h-9 items-center justify-center rounded-full overflow-hidden text-[22px] leading-none text-gray-950 no-underline hover:opacity-80 transition-opacity [&>i]:leading-none"
                  >
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.title || "social"}
                        className="w-9 h-9 rounded-full object-cover"
                      />
                    ) : (
                      <span dangerouslySetInnerHTML={{ __html: item.icon || "" }} />
                    )}
                  </a>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </footer>
  );
};

export default UserFooter;
